// One display field, without guessing where a person's first/last name splits.
const customerFullName = (customer = {}) =>
  [customer.first_name, customer.last_name].filter(Boolean).join(" ").trim();

const normalizeCustomerProfile = (input = {}, existing = {}) => {
  const result = { ...existing, ...input };
  if (Object.prototype.hasOwnProperty.call(input, "full_name")) {
    const name = String(input.full_name || "").trim();
    // Preserve historical name columns if the displayed name did not change.
    if (name !== customerFullName(existing)) {
      result.first_name = name;
      result.last_name = "";
    }
  }
  result.first_name = String(result.first_name || "").trim();
  result.last_name = String(result.last_name || "").trim();
  if (!customerFullName(result)) {
    const error = new Error("Le champ Nom & Prénom est obligatoire");
    error.status = 400;
    throw error;
  }
  result.phone = result.phone == null ? null : String(result.phone).trim() || null;
  return result;
};

const customerProfilePayload = ({ email, notes, ...profile }) => profile;

module.exports = { customerFullName, normalizeCustomerProfile, customerProfilePayload };
